import { css, Styles, verticalScrollCss, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  listContainer: ({ theme }) => css`
    & > div > div {
      ${verticalScrollCss(theme)}
    }
  `,
  menuItem: css`
    width: 100%;
    gap: 10px;
    height: 36px;
    flex-shrink: 0;
  `,
  menuItemWithEdit: css`
    & [data-job-list-trailing='quality'] {
      opacity: 1;
      transition: opacity 0.12s ease;
    }
    & [data-job-list-trailing='edit'] {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.12s ease;
    }
    &:hover [data-job-list-trailing='quality'] {
      opacity: 0;
      pointer-events: none;
    }
    &:hover [data-job-list-trailing='edit'] {
      opacity: 1;
      pointer-events: auto;
    }
  `,
  iconContainer: css`
    display: flex;
    flex-shrink: 0;
  `,
  qualityPill: css`
    margin-left: auto;
    flex-shrink: 0;
  `,
  trailingSlot: css`
    position: relative;
    margin-left: auto;
    flex-shrink: 0;
    min-width: 72px;
    min-height: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  trailingQuality: css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  editHitTarget: ({ theme }) => css`
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  empty: css`
    padding: 24px 16px;
    text-align: center;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
